module.exports = __webpack_public_path__ + "img/13.780bb5a0.jpg";